import {gql} from 'apollo-angular';

export const GET_SCHOOL_CLASS_YEARS = gql`
  query GetSchoolClassYears {
    schoolClassYears {
      id
      name
      startYear
      endYear
    }
  }
`;


